import { z } from 'zod';

// Schemas (source of truth)
export const baseFloorSchema = z.object({
	floorId: z.string(),
	floorNick: z.string(),
});

// Types (derived from schemas)
export type IBaseFloor = z.infer<typeof baseFloorSchema>;
